import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import { ForgotPassword } from 'api/endpoints';

const ForgetPasswordForm = () => {
  // State
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);


  const handleSubmit = (e) => {
    e.preventDefault();


    setLoading(true);
    ForgotPassword(email).then(res => {

      toast.success(`Reset password email has been sent to: ${email}`, {
        theme: "colored",
      });

      setLoading(false);
      navigate("/login");

    }).catch(err => {

      setLoading(false);
      toast.error(err?.message || "Reset password failed.", {
        autoClose: 1000,
      });

    });



  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Label>Email address</Form.Label>
      <Form.Group className="mb-3">
        <Form.Control
          // placeholder={'Email address'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email || loading}>
          Send reset link{loading && '...'}
        </Button>
      </Form.Group>

    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
